// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   ChangePassword.css — KinetiQ Change Password Page
   All styles inlined directly (no @import) for full CRA/webpack
   compatibility. Design tokens match Login.css & Register.css.
   The only visual difference vs EditAccount: submit button uses
   .account-btn-danger (red) instead of .account-btn-primary (teal).
   ================================================================ */

/* ================================================================
   AccountShared.css — KinetiQ Inner App Page Shared Styles
   Imported by BOTH EditAccount.css and ChangePassword.css.

   These are the common layout, card, form, and button rules so
   both pages stay pixel-perfect identical — only the submit
   button colour differs between them (teal vs red).

   Design tokens mirror Login.css / Register.css exactly:
     --kinetic-blue   #1A3C6E   headings, labels
     --kinetic-teal   #0B8DA6   teal CTA, focus rings
     --kinetic-accent #00C2A8   primary button bg
     --kinetic-light  #EBF4F8   input fill
     --kinetic-border #B8D4E0   borders
     --kinetic-gray   #6B7A8D   body text
     --kinetic-dark   #0D1F35   input text
   ================================================================ */

/* ── Page wrapper ──────────────────────────────────────────────
   MainLayout handles the outer shell + navbar.
   .account-page is the inner content area that sits inside
   MainLayout's <main> / content slot.                           */
.account-page {
  max-width: 620px;
  margin: 0 auto;
  padding: 40px 24px 60px;
  font-family: 'Inter', 'Segoe UI', sans-serif;
}

/* ── Page header ── */
.account-page-header {
  margin-bottom: 28px;
}

/* "MY ACCOUNT" / "SECURITY" eyebrow label — same as .login-card-label */
.account-page-label {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #0B8DA6;
  margin-bottom: 8px;
}

.account-page-header h1 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #1A3C6E;
  line-height: 1.15;
  letter-spacing: -0.022em;
  margin: 0 0 6px;
}

.account-page-header p {
  font-size: 0.92rem;
  color: #6B7A8D;
  line-height: 1.6;
  margin: 0;
}

/* ── Card — mirrors .login-card / .reg-card ── */
.account-card {
  background: #FFFFFF;
  border: 1.5px solid #B8D4E0;
  border-radius: 20px;
  padding: 36px 40px 40px;
  box-shadow: 0 8px 48px rgba(10, 50, 90, 0.10);
}

/* Section title inside the card */
.account-card-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  font-weight: 700;
  color: #1A3C6E;
  letter-spacing: 0.02em;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1.5px solid #B8D4E0;
}

.section-icon {
  font-size: 1rem;
}

/* ── Form ── */
.account-form {
  display: flex;
  flex-direction: column;
}

/* Two-column name row (EditAccount only) */
.account-name-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* Form group */
.account-form-group {
  margin-bottom: 18px;
}

.account-form-group label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: #1A3C6E;
  margin-bottom: 7px;
  letter-spacing: 0.02em;
}

/* Inputs — same spec as Login / Register */
.account-form-group input[type="text"],
.account-form-group input[type="password"],
.account-form-group input[type="email"] {
  display: block;
  width: 100%;
  background: #EBF4F8;
  border: 1.5px solid #B8D4E0;
  border-radius: 6px;
  padding: 13px 16px;
  color: #0D1F35;
  font-size: 0.94rem;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;
  -webkit-appearance: none;
}

.account-form-group input::placeholder {
  color: #9BAABB;
  font-size: 0.9rem;
}

.account-form-group input:hover {
  border-color: #0B8DA6;
}

.account-form-group input:focus {
  border-color: #0B8DA6;
  background: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(11, 141, 166, 0.13);
}

/* Thin horizontal rule between old and new password fields */
.account-field-divider {
  height: 1px;
  background: #B8D4E0;
  margin: 6px 0 20px;
}

/* Helper note below fields */
.account-field-note {
  font-size: 0.79rem;
  color: #9BAABB;
  line-height: 1.55;
  margin: 0 0 20px;
}

/* ── Form actions row ── */
.account-form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 4px;
  padding-top: 20px;
  border-top: 1px solid #B8D4E0;
}

/* ── Primary button (teal) — mirrors .login-submit-btn / .btn-primary ── */
.account-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #00C2A8;
  color: #0D1F35;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 13px 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  letter-spacing: 0.01em;
  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
  box-shadow: 0 4px 16px rgba(0, 194, 168, 0.30);
}

.account-btn-primary:hover {
  background: #00a896;
  transform: translateY(-2px);
  box-shadow: 0 6px 22px rgba(0, 194, 168, 0.40);
}

.account-btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 194, 168, 0.22);
}

/* ── Danger button (red) — for destructive actions like Change Password ── */
.account-btn-danger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #00C2A8;
  color: #FFFFFF;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 13px 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  letter-spacing: 0.01em;
  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
  box-shadow: 0 4px 16px rgba(229, 62, 62, 0.28);
}

.account-btn-danger:hover {
  background: #C53030;
  transform: translateY(-2px);
  box-shadow: 0 6px 22px rgba(229, 62, 62, 0.38);
}

.account-btn-danger:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.20);
}

/* ── RESPONSIVE ── */
@media (max-width: 600px) {
  .account-page {
    padding: 24px 16px 48px;
  }

  .account-card {
    padding: 28px 20px 32px;
    border-radius: 12px;
  }

  .account-name-row {
    grid-template-columns: 1fr;   /* stack first/last name vertically */
    gap: 0;
  }

  .account-form-actions {
    justify-content: stretch;
  }

  .account-btn-primary,
  .account-btn-danger {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ChangePassword.css"],"names":[],"mappings":"AAAA;;;;;;qEAMqE;;AAErE;;;;;;;;;;;;;;;;qEAgBqE;;AAErE;;;kEAGkE;AAClE;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;;;EAGE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,2EAA2E;AAC3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,sBAAsB;EACtB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,6EAA6E;AAC7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,sBAAsB;EACtB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B,IAAI,qCAAqC;IACnE,MAAM;EACR;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* ================================================================\n   ChangePassword.css — KinetiQ Change Password Page\n   All styles inlined directly (no @import) for full CRA/webpack\n   compatibility. Design tokens match Login.css & Register.css.\n   The only visual difference vs EditAccount: submit button uses\n   .account-btn-danger (red) instead of .account-btn-primary (teal).\n   ================================================================ */\n\n/* ================================================================\n   AccountShared.css — KinetiQ Inner App Page Shared Styles\n   Imported by BOTH EditAccount.css and ChangePassword.css.\n\n   These are the common layout, card, form, and button rules so\n   both pages stay pixel-perfect identical — only the submit\n   button colour differs between them (teal vs red).\n\n   Design tokens mirror Login.css / Register.css exactly:\n     --kinetic-blue   #1A3C6E   headings, labels\n     --kinetic-teal   #0B8DA6   teal CTA, focus rings\n     --kinetic-accent #00C2A8   primary button bg\n     --kinetic-light  #EBF4F8   input fill\n     --kinetic-border #B8D4E0   borders\n     --kinetic-gray   #6B7A8D   body text\n     --kinetic-dark   #0D1F35   input text\n   ================================================================ */\n\n/* ── Page wrapper ──────────────────────────────────────────────\n   MainLayout handles the outer shell + navbar.\n   .account-page is the inner content area that sits inside\n   MainLayout's <main> / content slot.                           */\n.account-page {\n  max-width: 620px;\n  margin: 0 auto;\n  padding: 40px 24px 60px;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n}\n\n/* ── Page header ── */\n.account-page-header {\n  margin-bottom: 28px;\n}\n\n/* \"MY ACCOUNT\" / \"SECURITY\" eyebrow label — same as .login-card-label */\n.account-page-label {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: #0B8DA6;\n  margin-bottom: 8px;\n}\n\n.account-page-header h1 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #1A3C6E;\n  line-height: 1.15;\n  letter-spacing: -0.022em;\n  margin: 0 0 6px;\n}\n\n.account-page-header p {\n  font-size: 0.92rem;\n  color: #6B7A8D;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* ── Card — mirrors .login-card / .reg-card ── */\n.account-card {\n  background: #FFFFFF;\n  border: 1.5px solid #B8D4E0;\n  border-radius: 20px;\n  padding: 36px 40px 40px;\n  box-shadow: 0 8px 48px rgba(10, 50, 90, 0.10);\n}\n\n/* Section title inside the card */\n.account-card-section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #1A3C6E;\n  letter-spacing: 0.02em;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1.5px solid #B8D4E0;\n}\n\n.section-icon {\n  font-size: 1rem;\n}\n\n/* ── Form ── */\n.account-form {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Two-column name row (EditAccount only) */\n.account-name-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n/* Form group */\n.account-form-group {\n  margin-bottom: 18px;\n}\n\n.account-form-group label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #1A3C6E;\n  margin-bottom: 7px;\n  letter-spacing: 0.02em;\n}\n\n/* Inputs — same spec as Login / Register */\n.account-form-group input[type=\"text\"],\n.account-form-group input[type=\"password\"],\n.account-form-group input[type=\"email\"] {\n  display: block;\n  width: 100%;\n  background: #EBF4F8;\n  border: 1.5px solid #B8D4E0;\n  border-radius: 6px;\n  padding: 13px 16px;\n  color: #0D1F35;\n  font-size: 0.94rem;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;\n  -webkit-appearance: none;\n}\n\n.account-form-group input::placeholder {\n  color: #9BAABB;\n  font-size: 0.9rem;\n}\n\n.account-form-group input:hover {\n  border-color: #0B8DA6;\n}\n\n.account-form-group input:focus {\n  border-color: #0B8DA6;\n  background: #FFFFFF;\n  box-shadow: 0 0 0 3px rgba(11, 141, 166, 0.13);\n}\n\n/* Thin horizontal rule between old and new password fields */\n.account-field-divider {\n  height: 1px;\n  background: #B8D4E0;\n  margin: 6px 0 20px;\n}\n\n/* Helper note below fields */\n.account-field-note {\n  font-size: 0.79rem;\n  color: #9BAABB;\n  line-height: 1.55;\n  margin: 0 0 20px;\n}\n\n/* ── Form actions row ── */\n.account-form-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 4px;\n  padding-top: 20px;\n  border-top: 1px solid #B8D4E0;\n}\n\n/* ── Primary button (teal) — mirrors .login-submit-btn / .btn-primary ── */\n.account-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #00C2A8;\n  color: #0D1F35;\n  font-weight: 700;\n  font-size: 0.95rem;\n  padding: 13px 28px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  letter-spacing: 0.01em;\n  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;\n  box-shadow: 0 4px 16px rgba(0, 194, 168, 0.30);\n}\n\n.account-btn-primary:hover {\n  background: #00a896;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 22px rgba(0, 194, 168, 0.40);\n}\n\n.account-btn-primary:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 194, 168, 0.22);\n}\n\n/* ── Danger button (red) — for destructive actions like Change Password ── */\n.account-btn-danger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #00C2A8;\n  color: #FFFFFF;\n  font-weight: 700;\n  font-size: 0.95rem;\n  padding: 13px 28px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  letter-spacing: 0.01em;\n  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;\n  box-shadow: 0 4px 16px rgba(229, 62, 62, 0.28);\n}\n\n.account-btn-danger:hover {\n  background: #C53030;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 22px rgba(229, 62, 62, 0.38);\n}\n\n.account-btn-danger:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.20);\n}\n\n/* ── RESPONSIVE ── */\n@media (max-width: 600px) {\n  .account-page {\n    padding: 24px 16px 48px;\n  }\n\n  .account-card {\n    padding: 28px 20px 32px;\n    border-radius: 12px;\n  }\n\n  .account-name-row {\n    grid-template-columns: 1fr;   /* stack first/last name vertically */\n    gap: 0;\n  }\n\n  .account-form-actions {\n    justify-content: stretch;\n  }\n\n  .account-btn-primary,\n  .account-btn-danger {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
